<template>
  <DashboardBase :children="children"/>
</template>

<script>
  import DashboardBase from './DashboardBase';
  import Design from './design/Design';
  import Orders from './orders/Orders';
  import Team from './team/Team';
  import Home from './home/Home';
  import Settings from './settings/Settings';

  const children = [
    {
      path: '/',
      component: Home,
      meta: {
        noBorder: true,
        //icon: 'fas fa-tachometer-alt',
        symbol: "dashboard",
      }
    },
    {
      path: 'design',
      component: Design,
      children: Design.children,
      meta: {
        // icon: 'fas fa-pencil-alt'
        symbol: "pencil",
      }
    },
    {
      path: 'team',
      component: Team,
      children: Team.children,
      meta: {
        // icon: 'fas fa-users'
        symbol: "team",
      }
    },
    {
      path: 'orders',
      component: Orders,
      children: Orders.children,
      meta: {
        //  icon: 'fas fa-sticky-note'
        symbol: "order",
      }
    },
    {
      path: 'settings',
      component: Settings,
      children: Settings.children,
      meta: {
        // icon: 'fas fa-cog',
        symbol: "gear"
      }
    }
  ];

  import {mapGetters} from 'vuex';
  export default {
    components: {
      DashboardBase,
    },
    computed: {
      ...mapGetters(['flags', 'isAdmin']),
      children() {
        return children.filter(({path}) => path !== 'team' || this.isAdmin || this.flags.showTeamTabToOrderers);
      }
    },
    // Non-standard Vue property, used to make sub
    children,
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/Dashboard.vue